<template>
    <chart-of-account-wrapper>
        <template v-slot:child>
            <manage-account-header />
            <div class="w-90 center mt4">
                <div class="flex justify-between items-center manageHeader secPad">
                    <div class="b w-50">Account</div>
                    <div class="b w-50">Description</div>
                    <div class="b">
                        <!-- Action -->
                    </div>
                </div>
                <section class="secPad">
                    <div class="flex justify-between items-center secFirst">
                        <div class="pl3">Owners Equity</div>
                        <div></div>
                        <div>
                            <!-- <button class="flex items-center" style="gap: 10px">
                                <span><img :src="require('@/assets/images/chartCircle.svg')" /></span><span>Add account</span>
                            </button> -->
                        </div>
                    </div>
                    <div class="flex justify-between items-center secPad">
                        <div class="w-50 b">
                            <router-link :to="{ name: 'EquityOwnersContribution' }">Owners Contribution</router-link>
                        </div>
                        <div class="w-50 tl">Owners contribution to company capital</div>
                        <!-- <div class="w-50 tr">
                            <img :src="require('@/assets/images/chartPen.svg')" />
                        </div> -->
                    </div>
                    <div class="flex justify-between items-center secPad">
                        <div class="w-50">Retained Income (Opening Balance)</div>
                        <div class="w-50 tl">Retained earning after dividend payment</div>
                        <!-- <div class="w-50 tr">
                            <img :src="require('@/assets/images/chartPen.svg')" />
                        </div> -->
                    </div>
                    <div class="flex justify-between items-center secPad">
                        <div class="w-50 b">
                            <router-link :to="{ name: 'EquityDrawings' }">Drawings</router-link>
                        </div>
                        <div class="w-50 tl">Withdrawals done by the owner(s) for personal expenses</div>
                        <!-- <div class="w-50 tr">
                            <img :src="require('@/assets/images/chartPen.svg')" />
                        </div> -->
                    </div>
                </section>
            </div>
        </template>
    </chart-of-account-wrapper>
</template>
<script>
import ChartOfAccountWrapper from '../widgets/ChartOfAccountWrapper.vue'
import ManageAccountHeader from '../widgets/ManageAccountHeader.vue'
export default {
    name: 'ManageEquity',
    components: { ManageAccountHeader, ChartOfAccountWrapper },
    setup() {
        return {}
    },
}
</script>
<style scoped>
.secPad div {
    align-items: flex-start !important;
}
</style>
